document.addEventListener("DOMContentLoaded", () => {
  const shell = document.querySelector(".site-shell, .product-shell");
  if (!shell) return;

  const toast = document.querySelector(".toast");
  const toastMessage = document.querySelector("[data-toast-message]");
  const toastCartLink = document.querySelector("[data-toast-cart]");
  const menuButton = document.querySelector(".mobile-menu-toggle");
  const nav = document.querySelector(".main-nav");
  const cartCount = document.querySelector(".cart-count");
  const quantityNode = document.querySelector(".quantity");
  const productDataNode = document.querySelector("[data-featured-product]");
  let quantity = Number(quantityNode?.textContent || 1);
  let cartTotal = Number(shell.dataset.cartCount || 0);
  let productData = null;

  try {
    productData = productDataNode ? JSON.parse(productDataNode.textContent) : null;
  } catch (error) {
    productData = null;
  }

  const showToast = (message, showCartLink = false) => {
    if (!toast) return;
    if (toastMessage) toastMessage.textContent = message;
    else toast.textContent = message;
    if (toastCartLink) toastCartLink.hidden = !showCartLink;
    toast.hidden = false;
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => { toast.hidden = true; }, 3600);
  };

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

  document.querySelectorAll("[data-scroll-to]").forEach((button) => {
    button.addEventListener("click", () => scrollTo(button.dataset.scrollTo));
  });

  menuButton?.addEventListener("click", () => {
    const isOpen = nav?.classList.toggle("is-open");
    menuButton.setAttribute("aria-expanded", String(Boolean(isOpen)));
  });

  nav?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      nav.classList.remove("is-open");
      menuButton?.setAttribute("aria-expanded", "false");
    });
  });

  const productGallery = document.querySelector("[data-product-gallery]");
  const mainProductImage = document.querySelector("[data-product-main-image]");
  productGallery?.querySelectorAll("[data-gallery-image]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!mainProductImage) return;
      mainProductImage.src = button.dataset.galleryImage || mainProductImage.src;
      mainProductImage.alt = button.dataset.galleryAlt || "";
      productGallery.querySelectorAll("[data-gallery-image]").forEach((item) => {
        const isActive = item === button;
        item.classList.toggle("is-active", isActive);
        item.setAttribute("aria-pressed", String(isActive));
      });
    });
  });

  document.querySelectorAll("[data-quantity]").forEach((button) => {
    button.addEventListener("click", () => {
      quantity = Math.max(1, Math.min(99, quantity + (button.dataset.quantity === "up" ? 1 : -1)));
      if (quantityNode) quantityNode.textContent = String(quantity);
    });
  });

  document.querySelector("[data-add-to-cart]")?.addEventListener("click", async (event) => {
    const button = event.currentTarget;
    const variant = productData?.variants?.find((item) => item.available) || productData?.variants?.[0];
    if (!variant?.id) {
      showToast("This gift set is not available yet. Please contact us for details.");
      return;
    }

    button.disabled = true;
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(variant.id), quantity }] })
      });
      if (!response.ok) throw new Error("Cart add failed");
      const cart = await fetch("/cart.js", { headers: { Accept: "application/json" } }).then((result) => result.json());
      cartTotal = Number(cart.item_count || cartTotal + quantity);
      if (cartCount) cartCount.textContent = String(cartTotal);
      showToast(`${quantity} gift set${quantity === 1 ? "" : "s"} added to cart.`, true);
    } catch (error) {
      showToast("We couldn't add that gift set. Please try again.");
    } finally {
      button.disabled = false;
    }
  });
});
